module.exports = { id: "bike-new", url: "/build/app/img/symbols.svg#bike-new", viewBox: "", toString: function() { return this.url; } };